import styles from "./ClientCard.module.css";
import {ICard} from "../ClientCardsList";
import {useTranslation} from "react-i18next";

interface ClientCardProps {
  cardInfo: ICard;
  handleRemove?: (cardId: string) => void;
  showButtons?: boolean;
}

const ClientCard = ({
  cardInfo,
  handleRemove,
  showButtons = true,
}: ClientCardProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.mainContainer}>
      <div className={styles.cardImageAndNumberContainer}>
        <div style={{ display: 'flex', alignItems: 'center', fontSize: 24, marginRight: 8}}>
          {cardInfo.flag}
        </div>
        <div className={styles.cardCustomNameAndNumberContainer}>
          <h3>{cardInfo.name ?? t(`accountMenu.noCardName`)}</h3>
          <span>**** {cardInfo.lastFourDigits}</span>
        </div>
      </div>
      {showButtons && (
        <div className={styles.buttonsContainer}>
          {/* <Link
            to={`/auth/client/account/cards/edit?id=${cardInfo.id}`}
            className={styles.editIconLink}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 12.6671V16H3.33287L13.1626 6.17026L9.82975 2.83738L0 12.6671ZM15.74 3.59284C16.0867 3.24622 16.0867 2.68629 15.74 2.33968L13.6603 0.259964C13.3137 -0.0866547 12.7538 -0.0866547 12.4072 0.259964L10.7807 1.8864L14.1136 5.21928L15.74 3.59284Z"
                fill="currentColor"
              />
            </svg>
          </Link> */}
          <button
            type="button"
            className={styles.removeIconLink}
            onClick={handleRemove ? () => handleRemove(cardInfo.id) : () => {}}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.87389 0L0 2.87389L1.46752 4.3414L5.09554 8.03057L1.46752 11.6586L0 13.065L2.87389 16L4.3414 14.5325L8.03057 10.8433L11.6586 14.5325L13.065 16L16 13.065L14.5325 11.6586L10.8433 8.03057L14.5325 4.3414L16 2.87389L13.065 0L11.6586 1.46752L8.03057 5.09554L4.3414 1.46752L2.87389 0Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default ClientCard;
